<template>
  <div id="v1-mainContainer" class="employee-section">
    <Header></Header>
    <div class="site-mid">
      <router-view />
    </div>
    <Footer></Footer>
  </div>
  <!---------------------------Create Ticket Modal Pop Up Start------------------->
  <CreateTicketPopup></CreateTicketPopup>
  <!---------------------------Create Ticket Modal Pop Up End------------------->

  <!---------------------------Team members Modal Pop Up Start------------------->
  <ProjectTeamMembersPopup></ProjectTeamMembersPopup>
  <!---------------------------Team members Modal Pop Up End------------------->

  <!---------------------------Issue Modal Pop Up Start------------------->
  <IssuePopup></IssuePopup>
  <!---------------------------Issue Modal Pop Up Start------------------->

  <!--------------------------- Delete File Modal Pop Up Start--------------------------->
  <DeleteFilePopup></DeleteFilePopup>
  <!--------------------------- Delete File Modal Pop Up End--------------------------->

  <!--------------------------- Download File Modal Pop Up Start--------------------------->
  <DownloadFilePopup></DownloadFilePopup>
  <!--------------------------- Download File Modal Pop Up End--------------------------->
  <!--------------------------- Delete Confirm Modal Pop Up Start--------------------------->
  <DeleteConfirmPopup></DeleteConfirmPopup>
  <!--------------------------- Delete Confirm Modal Pop Up End--------------------------->
</template>

<script lang="ts">
import { defineComponent } from "vue";
import constants from "@/utils/en-US-Employee.json";
import Header from "./header.vue";
import Footer from "./footer.vue";
import CreateTicketPopup from "./createTicketPopup.vue";
import ProjectTeamMembersPopup from "./projectTeamMembersPopup.vue";
import IssuePopup from "./issuePopup.vue";
import DeleteFilePopup from "./deleteFilePopup.vue";
import DownloadFilePopup from "./downloadFilePopup.vue";
import DeleteConfirmPopup from "./deleteConfirmPopup.vue";
import customJsv1 from "@/assets/lems-v1/js/custom.js";

export default defineComponent({
  name: "Layout",
  components: {
    Header,
    Footer,
    CreateTicketPopup,
    ProjectTeamMembersPopup,
    IssuePopup,
    DeleteFilePopup,
    DownloadFilePopup,
    DeleteConfirmPopup,
  },
  data() {
    return {
      constants,
    };
  },
  mounted() {
    customJsv1();
  },
});
</script>
